module.exports = __webpack_public_path__ + "static/media/4C.4eb1e98a.svg";